var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C13.2476 2.5 14.4831 2.74524 15.6357 3.22266C16.7883 3.70008 17.8356 4.40008 18.7178 5.28223C19.5999 6.16437 20.2999 7.21168 20.7773 8.36426C21.2548 9.51685 21.5 10.7524 21.5 12C21.5 14.5196 20.4994 16.9362 18.7178 18.7178C16.9362 20.4994 14.5196 21.5 12 21.5C6.74712 21.5 2.5 17.2248 2.5 12C2.5 9.48044 3.50063 7.06382 5.28223 5.28223C7.06382 3.50063 9.48044 2.5 12 2.5ZM12 3.5C9.74566 3.5 7.58332 4.3952 5.98926 5.98926C4.3952 7.58332 3.5 9.74566 3.5 12C3.5 14.2543 4.3952 16.4167 5.98926 18.0107C7.58332 19.6048 9.74566 20.5 12 20.5C14.2543 20.5 16.4167 19.6048 18.0107 18.0107C19.6048 16.4167 20.5 14.2543 20.5 12C20.5 9.74566 19.6048 7.58332 18.0107 5.98926C16.4167 4.3952 14.2543 3.5 12 3.5ZM12 7.5V12.5352L12.2451 12.6797L16.3096 15.0908L16.0811 15.4658L11.5 12.7168V7.5H12Z",
    stroke: "#221C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.a5bed955681a42133aab2b5e07a20c2a.svg";
export { ForwardRef as ReactComponent };